import React from "react";

export const ChatInviteAccept = ({
  handleAcceptInvite,
  handleDeclineInvite,
  handleCancelInvite,
  users,
  currentUser,
}) => {
  return (
    <div className="user-chat-list">
      {users.map((invite) => {
        const isSender = invite.senderId === currentUser.id;
        const status = invite.invitationStatus;
        
        // if I am sender -> show receiver’s info, else show sender’s info
        const displayUser = isSender ? invite.ReceiverUser : invite.SenderUser;

        return (
          <div key={invite.id} className="user-item-invite">
            <div className="user-item-invited-inner">
              {(displayUser && displayUser.image || invite.image) ? (
                <div style={{ borderRadius: "50%" }}>
                  <img
                    src={displayUser.image || invite.image}
                    height="48"
                    width="48"
                    alt="avatar"
                    style={{ borderRadius: "1rem" }}
                  />
                </div>
              ) : (
                <div className="contact-chat-logo">
                 {(displayUser && displayUser.name) || (invite && invite.name)
                    ? ((displayUser && displayUser.name) || (invite && invite.name))
                        .split(" ")
                        .map((part) => part[0])
                        .join("")
                    : "N/A"}
                </div>
              )}
              <span className="contact-chat-name">  {(displayUser && displayUser.name) || (invite && invite.name) || ""}</span>
            </div>

            {isSender && status === "PENDING" ? (
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span className="pending-text">Pending...</span>
                <button
                  className="chat-cancel-invite-button"
                  onClick={() => handleCancelInvite(invite)}
                >
                  Cancel
                </button>
              </div>
            ) : !isSender ? (
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <button
                  className="chat-accept-invite-button"
                  onClick={() => handleAcceptInvite(invite)}
                >
                  Accept
                </button>
                <button
                  className="chat-decline-invite-button"
                  onClick={() => handleDeclineInvite(invite)}
                >
                  Decline
                </button>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
